import {Injectable} from "@angular/core";
import {CredentialsStorage} from "@app/core/credentials/domain/credentials-storage";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {Observable} from "rxjs";
import {catchError, map, switchMap} from "rxjs/operators";
import {Product} from "../../product/domain/dtos/product";
import {CheckStockRemote} from "../domain/repositories/check-stock.remote";

@Injectable({
    providedIn: "root"
})
export class CheckStockWebService implements CheckStockRemote {

    public readonly CHECK_STOCK = 'stock';

    constructor(
        private baseHandler: EuropastryBaseHandler,
        private deliveryPointLocal: DeliveryPointLocal,
        private credentialsStorage: CredentialsStorage,
        private apiUrls: ApiUrls,
    ) { }

    checkStock(product: Product): Observable<number> {
        return this.deliveryPointLocal.currentDeliveryPointCode$.pipe(switchMap(deliveryPointCode => {

            const parameters = new HandlerBuilder()
                .method(HttpMethod.get)
                .url(this.apiUrls.CATALOG + deliveryPointCode + '/' + product.code + '/' + this.CHECK_STOCK)
                .authorization(this.credentialsStorage.getCredentials())
                .build()

            return this.baseHandler.execute(parameters).pipe(
                map(response => response.quantity),
                catchError(BaseHandleErrorMapper.handleError),
            );
        }));
    }

}
